import React, { useState, useEffect } from 'react';
import './TempleOSEmulator.css';

const TempleOSEmulator = ({ onClose }) => {
    const [isBooting, setIsBooting] = useState(true);
    const [bootProgress, setBootProgress] = useState(0);
    
    useEffect(() => {
        // Simulate boot process
        const bootTimer = setTimeout(() => {
            setIsBooting(false);
        }, 3000);
        
        const progressTimer = setInterval(() => {
            setBootProgress(prev => {
                if (prev >= 100) {
                    clearInterval(progressTimer);
                    return 100;
                }
                return prev + 10;
            });
        }, 300);
        
        return () => {
            clearTimeout(bootTimer);
            clearInterval(progressTimer);
        };
    }, []);
    
    const handleWebLink = () => {
        window.open('https://templeos.org/', '_blank');
    };
    
    return (
        <div className="templeos-modal-overlay" onClick={onClose}>
            <div className="templeos-container" onClick={(e) => e.stopPropagation()}>
                <div className="templeos-header">
                    <h2>THINGOL SANCTUARY SYSTEM - TEMPLE OS v4.0</h2>
                    <button className="close-templeos" onClick={onClose}>×</button>
                </div>
                
                <div className="boot-status">
                    {isBooting ? (
                        <div className="boot-loader">
                            <div className="boot-text">INITIALIZING SACRED SPACE...</div>
                            <div className="progress-bar">
                                <div 
                                    className="progress-fill" 
                                    style={{ width: `${bootProgress}%` }}
                                ></div>
                            </div>
                            <div className="boot-message">
                                 Loading God's Operating System...<br />
                                 Memory sanctified: 128MB<br />
                                 CPU blessed at 16MHz<br />
                                 SYSTEM READY
                            </div>
                        </div>
                    ) : (
                        <div className="oracle-interface">
                            <button className="web-link-btn" onClick={handleWebLink}>
                                ENTER THE SANCTUARY
                            </button>
                            <p className="oracle-instruction">
                                 The path to enlightenment awaits beyond this portal.<br />
                                 Click the button above to continue your journey.
                            </p>
                        </div>
                    )}
                </div>

                <div className="templeos-screen">
                    {isBooting ? "SYSTEM BOOTING..." : "SYSTEM STATUS: READY\nClick the button to proceed to templeos.org"}
                </div>

                <div className="templeos-terminal">
                    <p> SYSTEM: Temple OS v4.0 - "The Lord's Operating System"</p>
                    <p> ARCHITECTURE: 64-bit Holy Code</p>
                    <p> WARNING: This system exists outside corporate surveillance</p>
                    <p> COMMAND: Click the golden button for divine guidance</p>
                    <p> STATUS: {isBooting ? "Booting..." : "Connected. Ready to transcend."} <span className="blink">_</span></p>
                </div>
            </div>
        </div>
    );
};

export default TempleOSEmulator;